<script setup>
const route = useRoute();

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  totalPages: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue", 'changed']);

const currentPage = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newVal) => {
      currentPage.value = newVal;
    }
);

const goToPage = (newPage) => {
  currentPage.value = newPage;
  emit("update:modelValue", newPage);
  emit("changed", newPage);
};
</script>


<template>
  <nav aria-label="Pagination" class="pagination-container">
    <router-link
        :to="route.path + '?page=' + (currentPage - 1)"
        v-if="currentPage > 1"
        @click.prevent="goToPage(currentPage - 1)"
        aria-label="Previous page"
        class="paginate-buttons"
    >
      &larr;
    </router-link>

    <router-link
        :to="route.path + '?page=1'"
        v-if="currentPage > 2"
        @click="goToPage(1)"
        aria-label="Page 1"
        class="paginate-buttons"
    >
      1
    </router-link>

    <router-link
        :to="route.path + '?page=' + (currentPage - 2)"
        v-if="currentPage > 3"
        @click="goToPage(currentPage - 2)"
        :aria-label="`Page ${currentPage - 2}`"
        class="paginate-buttons"
    >
      ...
    </router-link>

    <router-link
        :to="route.path + '?page=' + (currentPage - 1)"
        v-if="currentPage > 1"
        @click="goToPage(currentPage - 1)"
        :aria-label="`Page ${currentPage - 1}`"
        class="paginate-buttons"
    >
      {{ currentPage - 1 }}
    </router-link>

    <button aria-current="page" class="paginate-buttons active-page">
      {{ currentPage }}
    </button>

    <router-link
        :to="route.path + '?page=' + (currentPage + 1)"
        v-if="currentPage < totalPages"
        @click="goToPage(currentPage + 1)"
        :aria-label="`Page ${currentPage + 1}`"
        class="paginate-buttons"
    >
      {{ currentPage + 1 }}
    </router-link>

    <router-link
        :to="route.path + '?page=' + (currentPage + 2)"
        v-if="currentPage < totalPages - 2"
        @click="goToPage(currentPage + 2)"
        :aria-label="`Page ${currentPage + 2}`"
        class="paginate-buttons"
    >
      ...
    </router-link>

    <router-link
        :to="route.path + '?page=' + totalPages"
        v-if="currentPage < totalPages - 1"
        @click="goToPage(totalPages)"
        :aria-label="`Page ${totalPages}`"
        class="paginate-buttons"
    >
      {{ totalPages }}
    </router-link>

    <router-link
        :to="route.path + '?page=' + (currentPage + 1)"
        v-if="currentPage < totalPages"
        @click="goToPage(currentPage + 1)"
        aria-label="Next page"
        class="paginate-buttons"
    >
      &rarr;
    </router-link>
  </nav>
</template>
